import script from "./LastTransactions.vue?vue&type=script&setup=true&lang=js"
export * from "./LastTransactions.vue?vue&type=script&setup=true&lang=js"

import "./LastTransactions.vue?vue&type=style&index=0&id=2f7ca4de&lang=scss"

const __exports__ = script;

export default __exports__